import React, { useState } from "react";
import { useQuery, useMutation } from "@apollo/client";
import styled from "@emotion/styled";
import { GET_USER_EDIT } from "../../../apollo-client/queries";
import { EDIT_USER_NAME } from "../../../apollo-client/mutations";
import { EditProfileUserData } from "../../edit-profile/edit-profile-user-data";
import { EditProfilePasswordForm } from "../../edit-profile/edit-profile-password-form";
import { ChangePictureDialog } from "./change-picture-dialog";
import { useRouteMatch } from "react-router-dom";

//mit container um thumbnail mit min height usw und in thumbnail width und height auf 100% hat sich das dem Bild automatisch angepasst! gut oder sclecht?
export const EditProfileFields = (props) => {
  //QUERIES
  const { data, error, loading } = useQuery(GET_USER_EDIT);

  const [newUsername, setNewUsername] = useState(data && data.user.username);

  //MUTATIONS
  const [changeName] = useMutation(EDIT_USER_NAME, {
    update(cache, addContentLinkResponse) {
      setNewUsername("");
      document.getElementById("editable_div_new_username").innerText = "";
    },
  });

  const routeMatch = useRouteMatch();

  const isChangePwInUrl = (props) => {
    const splittedPath = routeMatch.path.split("/");
    return splittedPath[splittedPath.length - 1] === "change-pw";
  };

  const isPictureChangeInUrl = (props) => {
    const splittedPath = routeMatch.path.split("/");
    return splittedPath[splittedPath.length - 1] === "picture-change";
  };

  return (
    <div>
      {!loading && data && (
        <Container>
          {!isChangePwInUrl(props) && !isPictureChangeInUrl(props) && (
            <EditProfileUserData user={data.user} props={props} />
          )}
          {isChangePwInUrl(props) && (
            <EditProfilePasswordForm
              user={data.user}
              props={props}
              newUsername={newUsername}
            />
          )}
          {isPictureChangeInUrl(props) && (
            <ChangePictureDialog />
          )}
        </Container>
      )}
    </div>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 15%;
  margin-top: 120px;

  @media only screen and (max-width: ${(props) =>
      props.theme.secondBreakpoint}px) {
    margin-top: 0px;
    justify-content: center;
    width: 100%;
  }
`;
